// import { Component, OnInit } from '@angular/core';
//
// @Component({
//   selector: 'app-counselling-sop',
//   templateUrl: './counselling-sop.component.html',
//   styleUrls: ['./counselling-sop.component.scss']
// })
// export class CounsellingSopComponent implements OnInit {
//
//   constructor() { }
//
//   ngOnInit(): void {
//   }
//
// }





import { Component, ElementRef, isDevMode, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {PermissionType} from "../../../../../components/employee/PermissionType.enum";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {environment} from "../../../../../../environments/environment";

@Component({
  selector: 'app-counselling-sop',
  templateUrl: './counselling-sop.component.html',
  styleUrls: ['./counselling-sop.component.scss']
})
export class CounsellingSopComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();

  @ViewChild('contentArea') contentArea!: ElementRef;
  @ViewChild('fileInput') fileInput!: ElementRef;

  editMode = false;
  logoSrc = 'assets/logo.png';
  userData = JSON.parse(localStorage.getItem('userData')!).userName

  constructor(private afs: AngularFirestore) {}

  // ngOnInit(): void {
  //   const savedHtml = localStorage.getItem('COUNSELLING_SOP_HTML');
  //   if (savedHtml) {
  //     setTimeout(() => {
  //       this.contentArea.nativeElement.innerHTML = savedHtml;
  //     });
  //   }
  // }

  // toggleEdit() {
  //   if (this.editMode) {
  //     const html = this.contentArea.nativeElement.innerHTML;
  //     localStorage.setItem('COUNSELLING_SOP_HTML', html);
  //     alert('Saved successfully!');
  //   }
  //   this.editMode = !this.editMode;
  // }





  executeCommand(command: string, value: string | null = null): void {
    document.execCommand(command, false, value || undefined);
    this.contentArea.nativeElement.focus();
  }

  insertTable(): void {
    const rows = prompt('Number of rows:', '3');
    const cols = prompt('Number of columns:', '3');

    if (rows && cols) {
      let tableHTML = '<table class="table table-bordered" style="margin:10px 0;"><tbody>';
      for (let i = 0; i < +rows; i++) {
        tableHTML += '<tr>';
        for (let j = 0; j < +cols; j++) {
          tableHTML += '<td style="border:1px solid #000;padding:8px;">Cell</td>';
        }
        tableHTML += '</tr>';
      }
      tableHTML += '</tbody></table>';

      document.execCommand('insertHTML', false, tableHTML);
    }
  }

  // changeLogo() {
  //   if (this.editMode) this.fileInput.nativeElement.click();
  // }

  // handleLogoChange(event: Event): void {
  //   const file = (event.target as HTMLInputElement).files?.[0];
  //   if (!file) return;
  //
  //   const reader = new FileReader();
  //   reader.onload = e => {
  //     this.logoSrc = e.target?.result as string;
  //     localStorage.setItem("COUNSELLING_SOP_LOGO", this.logoSrc);
  //   };
  //   reader.readAsDataURL(file);
  // }


  handleLogoChange(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = e => {
      this.logoSrc = e.target?.result as string;
      localStorage.setItem("COUNSELLING_SOP_LOGO", this.logoSrc);
    };
    reader.readAsDataURL(file);
  }




  // ------- Table Operations (same as Education SOP) -------

  addTableRow() {
    const cell = this.getCurrentTableCell();
    if (!cell) return alert('Place cursor inside a table');

    const row = cell.closest('tr');
    const newRow = row!.cloneNode(true) as HTMLTableRowElement;
    newRow.querySelectorAll('td').forEach(td => td.textContent = 'New Cell');
    row!.parentNode!.insertBefore(newRow, row!.nextSibling);
  }

  addTableColumn() {
    const cell = this.getCurrentTableCell();
    if (!cell) return alert('Place cursor inside a table');

    const table = cell.closest('table');
    const index = cell.cellIndex;

    table!.querySelectorAll('tr').forEach(row => {
      const newCell = (row as HTMLTableRowElement).cells[index].cloneNode() as HTMLTableCellElement;
      newCell.textContent = 'New';
      (row as HTMLTableRowElement).insertBefore(newCell, (row as HTMLTableRowElement).cells[index + 1]);
    });
  }

  deleteTableRow() {
    const cell = this.getCurrentTableCell();
    if (!cell) return alert('Place cursor inside a table');

    const row = cell.closest('tr');
    if (row!.parentNode!.children.length === 1)
      return alert('Cannot delete last row');
    row!.remove();
  }

  deleteTableColumn() {
    const cell = this.getCurrentTableCell();
    if (!cell) return alert('Place cursor inside a table');

    const index = cell.cellIndex;
    const table = cell.closest('table');
    const firstRow = table!.querySelector('tr') as HTMLTableRowElement;

    if (firstRow.cells.length === 1)
      return alert('Cannot delete last column');

    table!.querySelectorAll('tr').forEach(row => {
      (row as HTMLTableRowElement).deleteCell(index);
    });
  }

  deleteTable() {
    const cell = this.getCurrentTableCell();
    if (!cell) return alert('Place cursor inside table');

    const table = cell.closest('table');
    if (confirm('Delete table?')) table!.remove();
  }

  private getCurrentTableCell(): HTMLTableCellElement | null {
    const sel = window.getSelection();
    if (!sel || !sel.anchorNode) return null;

    let node: Node | null = sel.anchorNode;
    while (node && node !== this.contentArea.nativeElement) {
      if (node instanceof HTMLTableCellElement) return node;
      node = node.parentNode;
    }
    return null;
  }

  sopTitle = 'Counselling – SOP';


  // ngOnInit(): void {
  //   const savedLogo = localStorage.getItem("COUNSELLING_SOP_LOGO");
  //   if (savedLogo) this.logoSrc = savedLogo;
  //
  //   const savedBody = localStorage.getItem("COUNSELLING_SOP_BODY");
  //   if (savedBody) {
  //     setTimeout(() => {
  //       this.contentArea.nativeElement.innerHTML = savedBody;
  //     });
  //   }
  // }


  ngOnInit(): void {
    this.afs
      .collection(this.env.counsellingSOP)
      .doc("MAIN_SOP")
      .valueChanges()
      .pipe(takeUntil(this._destroyed$))
      .subscribe((data: any) => {
        if (!data) return;

        this.sopTitle = data.title;
        this.logoSrc = data.logo;

        setTimeout(() => {
          this.contentArea.nativeElement.innerHTML = data.body;
        });
      });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }


  // toggleEdit() {
  //   if (this.editMode) {
  //     // save ONLY body
  //     const html = this.contentArea.nativeElement.innerHTML;
  //     localStorage.setItem('SOP_BODY', html);
  //
  //     // save header separately
  //     localStorage.setItem('SOP_TITLE', this.sopTitle);
  //     localStorage.setItem('SOP_LOGO', this.logoSrc);
  //
  //     alert("Saved Successfully!");
  //   }
  //   this.editMode = !this.editMode;
  // }

  toggleEdit() {
    if (this.editMode) {
      this.saveSOP(); // save when switching from edit → view
    }

    this.editMode = !this.editMode;
  }


  saveSOP() {
    console.log("SAVE FUNCTION TRIGGERED!");

    const sopBody = this.contentArea.nativeElement.innerHTML;

    const sopData = {
      title: this.sopTitle,
      logo: this.logoSrc,
      body: sopBody,
      updatedAt: new Date(),
      createdAt: new Date()
    };

    this.afs
      .collection(this.env.counsellingSOP)
      .doc("MAIN_SOP")
      .set(sopData, { merge: true })
      .then(() => console.log("SAVED IN FIRESTORE"))
      .catch(err => console.error("ERROR:", err));
  }


  insertLink() {
    const url = prompt("Enter URL:");
    if (!url) return;

    const text = prompt("Enter display text:", url);
    if (!text) return;

    const linkHTML = `<a href="${url}" target="_blank">${text}</a>`;

    document.execCommand("insertHTML", false, linkHTML);
    this.contentArea.nativeElement.focus();
  }

  onTitleChange(event: any) {
    this.sopTitle = event.target.innerText;
  }

  exec(cmd: string, val: any = null) {
    document.execCommand(cmd, false, val);
    this.contentArea.nativeElement.focus();
  }

  // LOGO
  changeLogo() {
    if (!this.editMode) return;
    this.fileInput.nativeElement.click();
  }


  // handleLogo(event: any) {
  //   const file = event.target.files?.[0];
  //   if (!file) return;
  //
  //   const reader = new FileReader();
  //   reader.onload = e => this.logoSrc = e.target!.result as string;
  //   reader.readAsDataURL(file);
  // }


  resetToDefault() {
    localStorage.removeItem('SOP_BODY');
    window.location.reload();
  }


  protected readonly PermissionType = PermissionType;
}
